export const SELECT_ALL_ANNOTATIONS = 'SELECT_ALL_ANNOTATIONS';

const selectAllAnnotations = (state) => {
  const annotationIds = Object.keys(state.annotations || {});
  if (annotationIds.length === 0) {
    return state;
  }

  const { selectionsIds = [] } = state;
  if (
    selectionsIds.length === annotationIds.length &&
    annotationIds.every((id) => selectionsIds.includes(id))
  ) {
    return state;
  }

  return {
    ...state,
    selectionsIds: annotationIds,
  };
};

export default selectAllAnnotations;
